/**
 * @file: AiCreditNotice.tsx
 * @copyright: (c) 2019-2026 sichuan zhichetech co., ltd.
 */

import { Typography } from '@euler/app/components/typography';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { AiCreditAlertState } from '@euler/model/enum';
import React, { memo } from 'react';
import { View } from 'react-native';
import { useStyles } from '../styles';

const NOTICES: Partial<
  Record<AiCreditAlertState, { text: string; color: string; bg: string }>
> = {
  [AiCreditAlertState.Low]: {
    text: 'AI 积分余额不足，请联系门店管理员在门店后台「财务 › AI积分充值」充值',
    color: '#92400E',
    bg: '#FFFBEB',
  },
  [AiCreditAlertState.Exhausted]: {
    text: 'AI 积分已用完，请联系门店管理员在门店后台「财务 › AI积分充值」充值',
    color: '#B91C1C',
    bg: '#FEF2F2',
  },
};

/** Shown only while the store's balance is low or exhausted. */
export const AiCreditNotice = memo(function AiCreditNotice({
  alertState,
}: {
  alertState: AiCreditAlertState | null;
}) {
  const { rpx } = useResponsiveContext();
  const styles = useStyles();
  const notice = alertState ? NOTICES[alertState] : undefined;
  if (!notice) return null;
  return (
    <View style={[styles.creditNotice, { backgroundColor: notice.bg }]}>
      <Typography.Text size={rpx(12)} color={notice.color} lineHeight={rpx(18)}>
        {notice.text}
      </Typography.Text>
    </View>
  );
});
